import { useTranslation } from 'react-i18next';
import { Lightbulb } from 'lucide-react';
import type { HoldsDisplayMode } from './holds-display-mode';

interface HoldsModeToggleButtonProps {
  mode: HoldsDisplayMode;
  onToggle: () => void;
  /** Vertical position class (default 'bottom-2'); kept separate to avoid Tailwind conflicts. */
  positionClassName?: string;
  testId?: string;
}

/**
 * Lightbulb overlay button that cycles the holds display mode. Positioned at
 * the bottom-center of its (relative) parent by default. The icon reflects the
 * current mode: filled yellow = all holds, dimmed = none, outline = start&top.
 */
export function HoldsModeToggleButton({ mode, onToggle, positionClassName = 'bottom-2', testId = 'cover-holds-toggle' }: HoldsModeToggleButtonProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      title={t(`climbProfile.holdsMode.${mode}`)}
      aria-label={t(`climbProfile.holdsMode.${mode}`)}
      className={`absolute ${positionClassName} left-1/2 -translate-x-1/2 p-1.5 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors`}
      data-testid={testId}
    >
      <Lightbulb
        className={`h-4 w-4 ${mode === 'all' ? 'fill-yellow-300 text-yellow-300' : mode === 'none' ? 'opacity-40' : ''}`}
      />
    </button>
  );
}
